import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/heart.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/heart-full.svg';
import showNotification from '~/helpers/notification-helper';
export default {
  name: 'Heart',
  props: {
    reference: {
      type: String,
      required: true
    },
    withText: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      mdmUrls: {
        moodboard: '/account/moodboard'
      }
    };
  },
  computed: _objectSpread({}, mapGetters({
    user: 'customer/user',
    userLogged: 'customer/isConnected',
    wishlist: 'wishlist/wishlist',
    loadingWishlist: 'wishlist/loadingWishlist'
  }), {
    isInWishlist: function isInWishlist() {
      return this.wishlist && this.includesRef(this.reference);
    },
    btnText: function btnText() {
      return this.isInWishlist ? this.$t('delete.btn_label') : this.$t('add.btn_label');
    }
  }),
  watch: {
    user: function user() {
      if (this.userLogged && !this.loadingWishlist) {
        this.getWishlist();
      }
    }
  },
  methods: _objectSpread({}, mapActions({
    getWishlist: 'wishlist/getWishlist',
    hpost: 'wishlist/postItem',
    hdel: 'wishlist/deleteItem'
  }), {
    toggleWishlist: function toggleWishlist(ref, $event) {
      if (this.includesRef(ref)) {
        this.removeFromWishlist(ref, $event);
      } else {
        this.addToWishlist(ref, $event);
      }
    },
    includesRef: function includesRef(ref) {
      return this.wishlist != null && this.wishlist.product != null && this.wishlist.product.includes(ref);
    },
    addToWishlist: function () {
      var _addToWishlist = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(ref, $event) {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.userLogged) {
                  _context.next = 4;
                  break;
                }

                this.$root.$emit('open-layer', {
                  state: true,
                  name: 'LoginRegister'
                });
                this.tracking({
                  ref: ref,
                  action: 'Add-to-wishlist',
                  label: 'not_connected',
                  el: $event
                });
                return _context.abrupt("return");

              case 4:
                this.tracking({
                  ref: ref,
                  action: 'Add-to-wishlist',
                  el: $event
                });
                data = {
                  type: 'product',
                  reference: ref
                };
                _context.next = 8;
                return this.hpost(data);

              case 8:
                showNotification({
                  text: this.$i18n.messages[this.$store.state.i18n.currentLocale.language].add.subtitle,
                  destination: "/".concat(this.$store.state.i18n.currentLocale.market, "/").concat(this.$store.state.i18n.currentLocale.language).concat(this.mdmUrls.moodboard),
                  backgroundColor: 'green'
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addToWishlist(_x, _x2) {
        return _addToWishlist.apply(this, arguments);
      }

      return addToWishlist;
    }(),
    removeFromWishlist: function () {
      var _removeFromWishlist = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(ref, $event) {
        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.userLogged) {
                  _context2.next = 4;
                  break;
                }

                this.$root.$emit('open-layer', {
                  state: true,
                  name: 'LoginRegister'
                });
                this.tracking({
                  ref: ref,
                  action: 'Remove-from-wishlist',
                  label: 'not_connected',
                  el: $event
                });
                return _context2.abrupt("return");

              case 4:
                this.tracking({
                  ref: ref,
                  action: 'Remove-from-wishlist',
                  el: $event
                });
                data = {
                  type: 'product',
                  reference: ref
                };
                _context2.next = 8;
                return this.hdel(data);

              case 8:
                showNotification({
                  text: this.$i18n.messages[this.$store.state.i18n.currentLocale.language].delete.subtitle,
                  destination: "/".concat(this.$store.state.i18n.currentLocale.market, "/").concat(this.$store.state.i18n.currentLocale.language).concat(this.mdmUrls.moodboard),
                  backgroundColor: 'green'
                });

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function removeFromWishlist(_x3, _x4) {
        return _removeFromWishlist.apply(this, arguments);
      }

      return removeFromWishlist;
    }(),
    tracking: function () {
      var _tracking = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(_ref) {
        var ref, action, label, el, category, defaultLabel;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                ref = _ref.ref, action = _ref.action, label = _ref.label, el = _ref.el;
                category = '';

                if (window.tc_vars.env_template === 'listproduct_keyword') {
                  category = 'Search Page';
                }

                if (window.tc_vars.env_template === 'liste produits') {
                  category = 'Categorie';
                }

                if (window.tc_vars.env_template === 'page produit') {
                  category = 'FicheProduit';
                }

                defaultLabel = "".concat(window.tc_vars.page_cat1 || '', "_").concat(window.tc_vars.page_cat3 || '', "_").concat(ref);
                this.$root.$emit('generic-tracking', el, {
                  data: {
                    event_category: category,
                    event_action: action,
                    event_label: label || defaultLabel
                  }
                });

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function tracking(_x5) {
        return _tracking.apply(this, arguments);
      }

      return tracking;
    }()
  })
};